import React from 'react';
import { SectionTitle } from './SectionTitle';
import { stepTags, steps } from '../../data/artTherapy';
export function FourSteps() {
  return <section aria-labelledby="steps-title" className="bg-cream py-14 md:py-20" data-id="element-90" data-mp="654ycbojpapb">
      <div className="mx-auto max-w-5xl px-5" data-id="element-91" data-mp="kszslwi7bn4i">
        <SectionTitle id="steps-title" subtitle="Válassz egyet a több mint 150 tevékenység közül, készíts elő néhány egyszerű eszközt, és kövesd lépésről lépésre az utasításokat." data-id="element-92" data-mp="fv7ycvu33ox5">
          A feszültségtől a nagyobb nyugalomig, mindössze 4 egyszerű lépésben
        </SectionTitle>

        <ol className="mt-8 grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4" data-id="element-93" data-mp="161zj8z5s0ps">
          {steps.map((s, i) => <li key={s.title} className="flex flex-col items-center rounded-3xl border border-lavender-line bg-white px-3 py-6 text-center sm:px-5" data-id="element-94" data-mp="3t9uup9r6d3hj" data-mpi={i}>
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-lavender-line font-display text-lg font-bold text-ink" data-id="element-95" data-mp="1cnjyzw9pie6i">
                {i + 1}
              </span>
              <h3 className="mt-4 font-display text-[16px] font-bold leading-snug text-ink" data-id="element-96" data-mp="syrsvh0yvvhg">{s.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-body" data-id="element-97" data-mp="y08s783sz9vx">{s.text}</p>
            </li>)}
        </ol>

        <ul className="mx-auto mt-5 flex max-w-lg flex-wrap justify-center gap-3" data-id="element-98" data-mp="16yu96ytmmgul">
          {stepTags.map(t => <li key={t} className="rounded-full border border-lavender-line bg-[#F4EFF6] px-5 py-3 text-[13px] font-extrabold uppercase tracking-[0.08em] text-ink" data-id="element-99" data-mp="a9398k2kg1he">
              {t}
            </li>)}
        </ul>
      </div>
    </section>;
}